/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"

import Header2 from "../components/globals/header2"
import Footer from "../components/globals/footer"

import './bootstrap.min.css';
import "./layout.css"



const Layout = ({ children }) => (
  <>
  <Header2 />
  { children }
 <Footer />
  </>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
